module.exports = __webpack_public_path__ + "media/images/covid/icons/spray-15144e51e603b3ce3ebf450533f736a3.svg";